// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f1e361d4","703":"5a7d20d4"}[chunkId] + ".chunk.js";
};